import { languageMap } from ".."

languageMap.smali = {
	comments: {
		line: "#",
	},
}
